import { Component, forwardRef } from '@angular/core';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionByListComponent } from '../userAction-byList/userAction-byList.component';
import { ExportFilterService } from '../../../../Services/exportFilter.service';
import DataSource from 'devextreme/data/data_source';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { TranslateService } from '@ngx-translate/core';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { UserActionBaseComponent } from '../userAction-base.component';
import { SystemService } from '../../../../Services/system.service';
import { fieldNames } from '../../../../Model/FieldNames';

@Component({
  selector: 'userAction-deleteByList',
  templateUrl: 'userAction-deleteByList.component.html',
  styleUrls: ['../userActionSearchDeleteListStyle.css'],
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionDeleteByListComponent) }
  ]
})
export class UserActionDeleteByListComponent extends UserActionByListComponent {
  searchValues = ['SUPPLIER_PID', 'SUPPLIER_ALT_PID', 'INTERNATIONAL_PID', 'MANUFACTURER_NAME', 'PID', 'MANUFACTURER_PID'];
  searchValue = 'SUPPLIER_PID';

  loadingVisible = false;
  deleteEmptyMasters = false;

  manufacturerFilters = [];
  selectedManufacturer = [];

  manufacturerDataSource: DataSource;

  kommaTrennzeichen: boolean = true;
  semikolonTrennzeichen: boolean = true;
  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public exportFilterService: ExportFilterService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);

    this.geNoDataText = this.geNoDataText.bind(this);
    this.getSearchValueDisplayExpr = this.getSearchValueDisplayExpr.bind(this);
    this.loadingVisible = true;
    this.exportFilterService
      .getManufacturerFilters(this.catalogService.selectedCatalogId, this.loginService.currentUser.customerId)
      .toPromise()
      .then((filter: string[]) => {
        this.manufacturerFilters = filter.filter((x) => x != null);
        this.manufacturerDataSource = new DataSource({
          store: this.manufacturerFilters,
          paginate: true,
          pageSize: 10
        });
      })
      .finally(() => {
        this.loadingVisible = false;
      });
  }

  handlePropertyChange(event) {
    this.searchValue = event.item.value;
  }

  geNoDataText() {
    if (this.loadingVisible) {
      return 'Daten werden geladen';
    } else {
      return 'keine Daten gefunden';
    }
  }

  getSearchValueDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return this.translate.instant(item);
  }

  public createParameterStringAsJsonString(): string {
    this.inputList = this.formatListIgnoreSpace(this.inputList, this.kommaTrennzeichen, this.semikolonTrennzeichen);
      let values = this.inputList.length == 1 ? this.inputList[0] : this.inputList.split('\n');
      if (this.searchValue == fieldNames.manufacturerName) values = this.selectedManufacturer;
    return JSON.stringify({
      SearchValue: this.searchValue,
      Values: values,
      DeleteEmptyMasters: this.deleteEmptyMasters
    });
  }

  public async canStartMacro(): Promise<boolean> {
    let values = this.inputList;
    if (this.searchValue == 'MANUFACTURER_NAME')
      values = this.selectedManufacturer.join('\n');
    if (values == "" && this.kommaTrennzeichen == false && this.semikolonTrennzeichen == false) {
      this.systemService.notifyInfo(this.translate.instant('Bitte mindestens einen Wert, nach dem gesucht werden soll, eingeben'));
      return false;
    }
    return true;
  }

    public parseParameter(parameter: string) {

        const params = JSON.parse(parameter);
        this.selectedManufacturer = params.Values;
        this.inputList = params.Values;
        this.searchValue = params.SearchValue;
        this.deleteEmptyMasters = params.DeleteEmptyMasters;

    }
}
